import { render, staticRenderFns } from "./BoardDetailDefaultLayout.vue?vue&type=template&id=d8fa4bec&scoped=true"
import script from "./BoardDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./BoardDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa4bec",
  null
  
)

export default component.exports